import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Компонент для интеграции Telegram BackButton с React Router
 * Управляет отображением системной кнопки "Назад" в зависимости от текущего маршрута
 */
function TelegramRouter() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        if (!tg) return;

        const backButton = tg.BackButton;

        // На каких экранах нужна именно системная кнопка "Закрыть", а не "Назад":
        //  - на главном экране (`/`)
        //  - на экране результата (`/result`), когда письмо уже отправлено
        // В этих случаях мы скрываем Telegram BackButton — тогда Telegram сам
        // показывает стандартную кнопку закрытия (крестик).
        const isRootPath = location.pathname === '/';
        const isResultPath = location.pathname === '/result';

        // На промежуточных экранах (например, `/letter`) хотим видеть кнопку "Назад"
        // и управлять навигацией сами.
        if (!isRootPath && !isResultPath) {
            // Показываем кнопку "Назад"
            backButton.show();

            // Обработчик нажатия на кнопку "Назад"
            const handleBackClick = () => {
                navigate(-1); // Возвращаемся на предыдущий экран
            };

            // Устанавливаем обработчик
            backButton.onClick(handleBackClick);

            // Очистка при размонтировании или смене маршрута
            return () => {
                backButton.offClick(handleBackClick);
            };
        } else {
            // Скрываем кнопку "Назад" на главном и на экране результата,
            // чтобы Telegram показал системную кнопку закрытия.
            backButton.hide();
        }
    }, [location.pathname, navigate]);

    return null; // Этот компонент не рендерит UI
}

export default TelegramRouter;
